import { useState, useRef } from 'react';
import { Box, Textarea, Button } from '@chakra-ui/react';
import Icon from 'ui/components/Icons/Icon';
import { arcadeApiClient } from 'apiClients';
import styles from './Comments.module.css';
import { Comment } from 'types/Comment';
interface CommentsProps {
  itemId: number;
  onCreateComment: (Comment) => void;
}
const CommentInput = ({
  itemId,
  onCreateComment
}: CommentsProps) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const addComment = (body: string) => {
    if (!body || loading) return;
    setLoading(true);
    arcadeApiClient.post('/multi_platform/comments', {
      comment: {
        body,
        newsfeed_item_id: itemId
      }
    }).then(response => {
      setComment('');
      onCreateComment(response.data.comment);
    }).catch(console.error).finally(() => setLoading(false));
  };
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value);
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };
  const handleSubmit = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      addComment(comment);
    }
  };
  return <Box className={styles.inputContainer} data-sentry-element="Box" data-sentry-component="CommentInput" data-sentry-source-file="CommentInput.tsx">
      <Textarea ref={textareaRef} placeholder="Type your comment..." value={comment} onChange={handleChange} className={styles.commentInput} rows={1} onKeyDown={handleSubmit} data-sentry-element="Textarea" data-sentry-source-file="CommentInput.tsx" />
      <Button onClick={() => addComment(comment)} className={styles.commentButton} disabled={!comment || loading} backgroundColor={'luigisPants.500'} color={'white'} data-sentry-element="Button" data-sentry-source-file="CommentInput.tsx">
        <Icon name="ArrowUp" data-sentry-element="Icon" data-sentry-source-file="CommentInput.tsx" />
      </Button>
    </Box>;
};
export default CommentInput;